import classNames from 'classnames';
import React from 'react';
import LazyLoad from 'react-lazyload';

type LazyMediaType = 'image' | 'video';

interface LazyMediaProps extends React.HTMLProps<HTMLImageElement> {
  type: LazyMediaType;
  LazyClassName?: string;
}
const LazyMedia: React.FC<LazyMediaProps> = ({ type, LazyClassName, ...restProps }) => {
  const MediaComponent:string = type === 'image' ? 'img' : 'video';

  return (
    <LazyLoad className={LazyClassName}>
      <MediaComponent {...restProps} />
    </LazyLoad>
  );
};

export default LazyMedia;
